.content-popover {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 155px;
}
